"use client";
import clsx from "clsx";
import { type Control, type FieldValues, type Path, useController } from "react-hook-form";

type Props<T extends FieldValues> = {
  label: string;
  name: Path<T>;
  control: Control<T>;
  placeholder?: string;
  className?: string;
  id?: string;
  autoComplete?: string | undefined;
};
export const Textarea = <T extends FieldValues>({
  label,
  control,
  placeholder,
  className,
  name,
  id,
  autoComplete,
}: Props<T>) => {
  const {
    field: { onBlur, onChange, ref, value, disabled },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={clsx("text-base font-bold", {
          "text-[#C92A2A]": error,
          "text-[#22201F]": !error,
        })}
      >
        {label}
      </label>
      <div className="relative mt-2">
        <textarea
          id={id}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          ref={ref}
          className={clsx(
            "bg-white rounded-lg border py-3 px-4 w-full text-base font-normal placeholder:text-[#B8B8B8] h-28 resize-none",
            {
              "text-[#C92A2A] border-[#C92A2A]": error,
              "text-[#22201F] border-[#E5E5E5]": !error,
            },
          )}
          placeholder={placeholder}
          autoComplete={autoComplete}
        />
      </div>
      {error?.message && <p className="text-[#C92A2A] text-xs leading-5 mt-1">{error.message}</p>}
    </div>
  );
};
